const initialState = {
inquirySearch: []
};
const search = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SEARCH_ITEM':
            return {
                ...state,
                [action.key]: action.value
            }
        case 'CLEAR_SEARCH_ITEM':
            return {
                ...state,
                [action.key]: []
            }
        default:
            return state;
    }
}
export default search;


// WEBPACK FOOTER //
// ./src/app/utils/reducers/search.js